import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { RecoverAccountComponent } from './pages/recover-account/recover-account.component';
import { ChangePwComponent } from './pages/change-pw/change-pw.component';
import {RegisterExpressRetailComponent} from './pages/register-express-retail/register-express-retail.component';

const routes: Routes = [
  { path: '', component: SignInComponent },
  { path: 'sign-up', component:  SignUpComponent},
  { path: 'recover', component: RecoverAccountComponent },
  { path: 'change', component: ChangePwComponent },
  { path: 'register-express', component: RegisterExpressRetailComponent}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
